import React, { useEffect, useState,useCallback } from "react";
import { useParams,useNavigate } from "react-router-dom";
import "./editdetail.css";

const EditDetail = () => {
  const { dev_id } = useParams();
  const navigate = useNavigate();
  const [device, setDevice] = useState(null);
  const [subscriptionDays, setSubscriptionDays] = useState("");
  const [formData, setFormData] = useState({
    dev_id: "",
    model: "",
    brand: "",
    mac: ["", "", "", "", "", ""], // Store MAC as an array
    sub_location: "",
    pincode: "",
    city: "",
    state: "",
    branch: "",
    latitude: "",
    longitude: "",
    dev_install_date: "",
    subscription_start_date: "",
    subscription_end_date: "",
    customer_id: "",
    customer_name: "",
  });
  const [dateTime, setDateTime] = useState({
    dev_install_date: { day: "", month: "", year: "", hour: "", minute: "" },
    subscription_start_date: { day: "", month: "", year: "", hour: "", minute: "" },
    subscription_end_date: { day: "", month: "", year: "", hour: "", minute: "" },
  });


  const fetchDeviceDetails = useCallback(async () => {
    try {
      const response = await fetch(
        `https://6vpgfpbqbg.execute-api.ap-south-1.amazonaws.com/getdetails/${dev_id}`
      );
      const result = await response.json();

    setDevice(result);

    // Initialize formData with default values
    const devInstallDate = result.data.subscription?.dev_install_date
      ? new Date(result.data.subscription.dev_install_date * 1000)
      : new Date();
    const subscriptionStartDate = result.data.subscription?.subscription_start_date
      ? new Date(result.data.subscription.subscription_start_date * 1000)
      : new Date();
    const subscriptionEndDate = result.data.subscription?.subscription_end_date
      ? new Date(result.data.subscription.subscription_end_date * 1000)
      : new Date();

    setFormData({
      dev_id: result.data.dev_id || "",
      model: result.data.device?.brand || "",
      brand: result.data.device?.mfr || "",
      mac: result.data.device?.mac_id
        ? result.data.device.mac_id.split(":")
        : ["", "", "", "", "", ""],
      sub_location: result.data.location?.sub_location || "",
      pincode: result.data.location?.pincode || "",
      city: result.data.location?.city || "",
      state: result.data.location?.state || "",
      branch: result.data.location?.branch || "",
      latitude: result.data.location?.latitude || "",
      longitude: result.data.location?.longitude || "",
      dev_install_date: devInstallDate.toISOString().slice(0, 16),
      subscription_start_date: subscriptionStartDate.toISOString().slice(0, 16),
      subscription_end_date: subscriptionEndDate.toISOString().slice(0, 16),
      customer_id: result.data.subscription?.Customer_ID || "", // Get customer ID
      customer_name: result.data.subscription?.Customer_name || "",
    });

    // Initialize dateTime state with parsed dates
    setDateTime({
      dev_install_date: {
        day: devInstallDate.getDate(),
        month: devInstallDate.getMonth() + 1,
        year: devInstallDate.getFullYear(),
        hour: devInstallDate.getHours(),
        minute: devInstallDate.getMinutes(),
      },
      subscription_start_date: {
        day: subscriptionStartDate.getDate(),
        month: subscriptionStartDate.getMonth() + 1,
        year: subscriptionStartDate.getFullYear(),
        hour: subscriptionStartDate.getHours(),
        minute: subscriptionStartDate.getMinutes(),
      },
      subscription_end_date: {
        day: subscriptionEndDate.getDate(),
        month: subscriptionEndDate.getMonth() + 1,
        year: subscriptionEndDate.getFullYear(),
        hour: subscriptionEndDate.getHours(),
        minute: subscriptionEndDate.getMinutes(),
      },
    });
    if (result.data.subscription?.subscription_start_date && result.data.subscription?.subscription_end_date) {
      const startDate = new Date(result.data.subscription.subscription_start_date * 1000);
      const endDate = new Date(result.data.subscription.subscription_end_date * 1000);
      const diffInDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)); // Calculate the difference in days
      setSubscriptionDays(diffInDays.toString()); // Set the state, converting to string
    }
  } catch (error) {
    console.error("Error fetching device details:", error);
  }
}, [dev_id]);

useEffect(() => {
  fetchDeviceDetails();
}, [fetchDeviceDetails]);

const [isFormValid, setIsFormValid] = useState(false);

// Memoize validateForm
const validateForm = useCallback(() => {
  const requiredFields = [
    "model",
    "brand",
    "sub_location",
    "pincode",
    "city",
    "state",
    "branch",
    "latitude",
    "longitude",
    "customer_id",
    "customer_name",
  ];

  const allRequiredFilled = requiredFields.every((field) => formData[field].trim() !== "");
  const isMacValid = formData.mac.every((part) => part.length === 2);
  const isSubscriptionDaysValid =
    subscriptionDays.trim() !== "" &&
    !isNaN(subscriptionDays) &&
    parseInt(subscriptionDays, 10) >= 1 &&
    parseInt(subscriptionDays, 10) <= 20000000;

  setIsFormValid(allRequiredFilled && isMacValid && isSubscriptionDaysValid && formData.subscription_end_date.trim() !== "");
}, [formData, subscriptionDays]);

useEffect(() => {
  validateForm();
}, [validateForm]);

const handleSubscriptionDaysChange = (e) => {
  const inputValue = e.target.value;

    // Allow only numeric input
    const numericValue = inputValue.replace(/[^0-9]/g, ''); // Remove non-numeric characters

    const parsedValue = parseInt(numericValue, 10);

    if (numericValue === "" || (parsedValue <= 20000000 && parsedValue >= 0)) {
        setSubscriptionDays(numericValue);
    }
};

useEffect(() => {
  if (formData.subscription_start_date && subscriptionDays) {
    const startDate = new Date(formData.subscription_start_date);
    const days = parseInt(subscriptionDays, 10);

    if (!isNaN(days)) {
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + days);
      const timezoneOffset = endDate.getTimezoneOffset() * 60000;
      const enddate = new Date(endDate.getTime() - timezoneOffset)
      const endDateString = enddate.toISOString().slice(0, 16);

      setFormData((prev) => ({ ...prev, subscription_end_date: endDateString }));
      setDateTime((prev) => ({
        ...prev,
        subscription_end_date: {
          day: endDate.getDate(),
          month: endDate.getMonth() + 1,
          year: endDate.getFullYear(),
          hour: endDate.getHours(),
          minute: endDate.getMinutes(),
        },
      }));
    } else {
      // Handle invalid input
      setFormData((prev) => ({ ...prev, subscription_end_date: "" }));
      setDateTime((prev) => ({
        ...prev,
        subscription_end_date: { day: "", month: "", year: "", hour: "", minute: "" },
      }));
    }
  } else {
    setFormData((prev) => ({ ...prev, subscription_end_date: "" }));
    setDateTime((prev) => ({
      ...prev,
      subscription_end_date: { day: "", month: "", year: "", hour: "", minute: "" },
    }));
  }
}, [formData.subscription_start_date, subscriptionDays]);



const handleDateTimeChange = (field, type, value) => {
  setDateTime((prev) => {
    const updatedDateTime = {
      ...prev,
      [field]: {
        ...prev[field],
        [type]: value,
      },
    };

    let dateString = "";

    if (
      updatedDateTime[field].year &&
      updatedDateTime[field].month &&
      updatedDateTime[field].day &&
      updatedDateTime[field].hour !== "" &&
      updatedDateTime[field].minute !== ""
    ) {
      // Create a Date object in local time
      const date = new Date(
        updatedDateTime[field].year,
        updatedDateTime[field].month - 1, // Month is 0-indexed
        updatedDateTime[field].day,
        updatedDateTime[field].hour,
        updatedDateTime[field].minute
      );

      // Adjust for timezone offset to get the correct local time in ISO format
      const timezoneOffset = date.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
      const localDate = new Date(date.getTime() - timezoneOffset);
      dateString = localDate.toISOString().slice(0, 16); // Format as "YYYY-MM-DDTHH:MM"
    }

    // Update formData immediately after updating dateTime
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: dateString,
    }));

    return updatedDateTime;
  });

  if (field === "subscription_start_date") {
    setSubscriptionDays(""); // Clear the number of days input
  }
};

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 41 }, (_, i) => currentYear + i);
  };
  
  const getMonths = () => {
    return Array.from({ length: 12 }, (_, i) => i + 1);
  };
  
  const getDays = (year, month) => {
    return new Date(year, month, 0).getDate();
  };
  
  const getHours = () => {
    return Array.from({ length: 24 }, (_, i) => i);
  };
  
  const getMinutes = () => {
    return Array.from({ length: 60 }, (_, i) => i);
  };

  const renderDateTimeDropdowns = (field) => {
    const { day, month, year, hour, minute } = dateTime[field];
    const daysInMonth = getDays(year, month);

    return (
      <div className="datetime-dropdowns">
      <div className="date-time-container">
        <div className="date-time-labels">
          <span>DD</span>
          <span>MM</span>
          <span>YY</span>
          <span>HR</span>
          <span>MIN</span>
        </div>
        <div className="date-time-selects">
          <select
            value={day}
            onChange={(e) => handleDateTimeChange(field, "day", e.target.value)}
          >
            <option value="">Day</option>
            {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
          <select
            value={month}
            onChange={(e) => handleDateTimeChange(field, "month", e.target.value)}
          >
            <option value="">Month</option>
            {getMonths().map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
          <select
            value={year}
            onChange={(e) => handleDateTimeChange(field, "year", e.target.value)}
          >
            <option value="">Year</option>
            {getYears().map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          <select
            value={hour}
            onChange={(e) => handleDateTimeChange(field, "hour", parseInt(e.target.value, 10))}
          >
            <option value="">Hour</option>
            {getHours().map((h) => (
              <option key={h} value={h}>
                {h}
              </option>
            ))}
          </select>
          <select
            value={minute}
            onChange={(e) => handleDateTimeChange(field, "minute", parseInt(e.target.value, 10))}
          >
            <option value="">Minute</option>
            {getMinutes().map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
    );
  };
  const indianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi", "Lakshadweep", "Ladakh", "Puducherry" // Include Union Territories
].map(state => state.toUpperCase());

  const renderStateDropdown = () => (
    <select name="state" value={formData.state} onChange={handleChange} required>
      <option value="">Select State</option>
      {indianStates.map((state) => (
        <option key={state} value={state}>
          {state}
        </option>
      ))}
    </select>
  );
  const fetchCityStateFromPincode = async (pincode) => {
    if (pincode.length === 6) {
      try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
        const data = await response.json();
        if (data[0].Status === "Success") {
          setFormData((prev) => ({
            ...prev,
            city: data[0].PostOffice[0].District.toUpperCase(),
            state: data[0].PostOffice[0].State.toUpperCase(),
          }));
        }
      } catch (error) {
        console.error("Error fetching city and state:", error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "state") { // Special handling for state
      setFormData({ ...formData, [name]: value }); // Don't convert to uppercase
    } else {
        setFormData({ ...formData, [name]: value.toUpperCase() }); // Convert others to uppercase
    } // Convert to uppercase
    if (name === "pincode") {
      fetchCityStateFromPincode(value);
    }
  };


  const handleMacChange = (index, value, nextInput) => {
    const validMacPattern = /^[A-Za-z0-9]{0,2}$/;

    if (validMacPattern.test(value)) {
      setFormData((prev) => {
        const mac = [...prev.mac];
        mac[index] = value.toUpperCase();
        return { ...prev, mac };
      });

      if (value.length === 2 && nextInput) {
        nextInput.focus();
      }
    }
  };


  const handleMacKeyDown = (index, event, prevInput) => {
    if (event.key === "Backspace" && formData.mac[index] === "" && prevInput) {
      prevInput.focus();
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Ensure required fields are not empty
    if (!formData.model.trim()) {
      alert("Model cannot be empty");
      return;
    }
    if (!formData.brand.trim()) {
      alert("Brand cannot be empty");
      return;
    }
    if (formData.mac.some((part) => part.length !== 2)) {
      alert("MAC ID must be complete (6 pairs of 2 characters)");
      return;
    }
    if (new Date(formData.subscription_end_date) < new Date(formData.subscription_start_date)) {
      alert("Subscription end date cannot be earlier than start date");
      return;
    }

    try {
      const updatedData = {
        ...formData,
        mac_id: formData.mac.join(":"), // Convert MAC array to string
        subscription: {
          dev_install_date: Math.floor(new Date(formData.dev_install_date).getTime() / 1000),
          subscription_start_date: Math.floor(new Date(formData.subscription_start_date).getTime() / 1000),
          subscription_end_date: Math.floor(new Date(formData.subscription_end_date).getTime() / 1000),
          customer_id: formData.customer_id, // Include customer ID
          customer_name: formData.customer_name, // Include customer name
        },
        location: {
          sub_location: formData.sub_location,
          pincode: formData.pincode,
          city: formData.city,
          state: formData.state,
          branch: formData.branch,
          latitude: formData.latitude,
          longitude: formData.longitude,
        },
      };
      console.log(updatedData)

      const response = await fetch(
        `https://6vpgfpbqbg.execute-api.ap-south-1.amazonaws.com/updatedevice/${dev_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updatedData),
        }
      );

      const result = await response.json();
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${result.message}`);
      }

      alert("Device updated successfully");
    } catch (error) {
      console.error("Error updating device:", error);
      alert("Failed to update device: " + error.message);
    }
  };

  if (!device) return <p>Loading...</p>;

  return (
    <div className="editdetail-container">
      <h2>Edit Device Details</h2>
      <form onSubmit={handleSubmit}>
        <label>Device ID:</label>
        <input type="text" name="dev_id" value={formData.dev_id} disabled />

        <label>Model:</label>
        <input type="text" name="model" value={formData.model} onChange={handleChange} required />

        <label>Brand:</label>
        <input type="text" name="brand" value={formData.brand} onChange={handleChange} required />

        <label>MAC ID:</label>
        <div className="macs-id-container">
          {formData.mac.map((part, index) => (
            <input
              key={index}
              type="text"
              maxLength="2"
              value={part}
              onChange={(e) =>
                handleMacChange(index, e.target.value, document.getElementById(`mac-${index + 1}`))
              }
              onKeyDown={(e) =>
                handleMacKeyDown(index, e, document.getElementById(`mac-${index - 1}`))
              }
              required
              id={`mac-${index}`}
            />
          ))}
        </div>
        <label>Customer ID:</label>
        <input
          type="text"
          name="customer_id"
          value={formData.customer_id}
          onChange={handleChange}
        />

        <label>Customer Name:</label>
        <input
          type="text"
          name="customer_name"
          value={formData.customer_name}
          onChange={handleChange}
        />

        <label>Sub Location:</label>
        <input type="text" name="sub_location" value={formData.sub_location} onChange={handleChange} />

        <label>Pincode:</label>
        <input type="text" name="pincode" value={formData.pincode} onChange={handleChange} />

        <label>City:</label>
        <input type="text" name="city" value={formData.city} onChange={handleChange} />

        <label>State:</label>
          {renderStateDropdown()}

        <label>Branch:</label>
        <input type="text" name="branch" value={formData.branch} onChange={handleChange} />

        <label>Dev Install Date:</label>
        {renderDateTimeDropdowns("dev_install_date")}

        <label>Subscription Start Date:</label>
        {renderDateTimeDropdowns("subscription_start_date")}

        <label>Subscription End Date (Days):</label>
        <input
          type="number"
          value={subscriptionDays}
          onChange={handleSubscriptionDaysChange}
          min="1"
        />

        <button 
          type="submit" 
          className="update-button" 
          disabled={!isFormValid}
        >
          Update
        </button>
        <button type="button" onClick={handleCancel} className="cancel-button">Go Back</button>
      </form>
    </div>
  );
};

export default EditDetail;
